import React from 'react'
import { Field, reduxForm, FormSection } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons } from '../../components'

let FeedbackForm = ({
  submitting,
  pristine,
  reset,
  handleSubmit,
}) => {
  const params = [
    'Overall Satisfaction',
    'Technical Ability ',
    'Professionalism',
    'Response Time',
    'Timely Update',
  ]
  const choices = [
    'Very Satisfied',
    'Satisfied',
    'Neither Satisfied not Dissatisfied ',
    'Not Satisfied',
    'Very  Dissatisfied',
    "Don't Want to Answer",
  ]

  return (
    <form onSubmit={handleSubmit}>
      <FormSection name="customer_feedback">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col className={'p-0'} xs="12">
            <ReactBootstrap.Table striped bordered hover>
              <tbody>
                {params.map((p) => {
                  return (
                    <tr>
                      <td>
                        <div
                          style={{
                            paddingTop: '16px',
                            textAlign: 'left',
                            fontWeight: '600',
                          }}
                        >
                          {p}
                        </div>
                      </td>
                      <td>
                        {choices.map((c) => {
                          return (
                            <label className="p-3">
                              <Field
                                name={p.split(' ').join('_').toLowerCase()}
                                component="input"
                                type="radio"
                                value={c}
                              />
                              <span className="p-2">{c}</span>
                            </label>
                          )
                        })}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </ReactBootstrap.Table>
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className={'p-0'} xs="12">
            <FormButtons
              submitting={submitting}
              pristine={pristine}
              reset={reset}
            />
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </FormSection>
    </form>
  )
}
FeedbackForm = reduxForm({
  form: 'FeedbackForm',
})(FeedbackForm)

export default FeedbackForm
